import { render, staticRenderFns } from "./ADCVDDetail.vue?vue&type=template&id=0ffd1884&"
import script from "./ADCVDDetail.vue?vue&type=script&lang=js&"
export * from "./ADCVDDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports